import { createActionTypes } from "@helpers/redux-helpers";

export const getLocationBlockerLocationsActionTypes = createActionTypes(
  "location-blocker/get",
);
export const setLocationBlockerActionTypes = createActionTypes(
  "location-blocker/set",
);
export const deleteLocationBlockerActionTypes = createActionTypes(
  "location-blocker/delete",
);
